import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const tiers = [{
  name: 'Zephyr',
  price: '€29',
  description: 'For small teams getting started.',
  features: ['5 active workflows', '1,000 runs/month', '10 connectors', 'Email support'],
  highlighted: false
}, {
  name: 'Stratos',
  price: '€79',
  description: 'For growing teams.',
  features: ['25 active workflows', '10,000 runs/month', '50 connectors', 'Priority support', 'Meridian Dashboard'],
  highlighted: true,
  badge: 'Most Popular'
}, {
  name: 'Aether',
  price: '€199',
  description: 'For enterprises.',
  features: ['Unlimited workflows', 'Unlimited runs', 'All connectors', 'Dedicated success manager', 'SSO & Custom SLA'],
  highlighted: false
}];
export function PricingSection() {
  return <section id="pricing" className="py-24 bg-slate-50 relative" data-id="element-171">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-172">
        <div className="text-center mb-16" data-id="element-173">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-174">
            Simple, Transparent Pricing
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-175">
            Choose the plan that fits your scale. Upgrade or downgrade anytime.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 items-start" data-id="element-176">
          {tiers.map((tier, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} whileHover={{
          y: -5
        }} className={`relative bg-white rounded-2xl p-8 shadow-sm border ${tier.highlighted ? 'border-sky-500 ring-4 ring-sky-500/10 z-10' : 'border-slate-200'}`} data-id="element-177">
              {tier.highlighted && <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-sky-500 text-white px-4 py-1 rounded-full text-sm font-semibold shadow-md" data-id="element-178">
                  {tier.badge}
                </div>}

              <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-179">
                {tier.name}
              </h3>
              <div className="flex items-baseline mb-4" data-id="element-180">
                <span className="text-4xl font-bold text-slate-900" data-id="element-181">
                  {tier.price}
                </span>
                <span className="text-slate-500 ml-1" data-id="element-182">/month</span>
              </div>
              <p className="text-slate-600 mb-8 text-sm" data-id="element-183">{tier.description}</p>

              <ul className="space-y-4 mb-8" data-id="element-184">
                {tier.features.map((feature, i) => <li key={i} className="flex items-start gap-3 text-sm text-slate-700" data-id="element-185">
                    <Check size={18} className="text-sky-500 flex-shrink-0 mt-0.5" data-id="element-186" />
                    {feature}
                  </li>)}
              </ul>

              <button className={`w-full py-3 px-4 rounded-lg font-semibold transition-colors ${tier.highlighted ? 'bg-sky-500 text-white hover:bg-sky-600 shadow-md' : 'bg-slate-100 text-slate-900 hover:bg-slate-200'}`} data-id="element-187">
                Get Started
              </button>
            </motion.div>)}
        </div>
      </div>
    </section>;
}